import CONSENTS_TO_VALIDATE from 'shared-constants/src/consentsToValidate';

/**
 * try to get the consents from the user
 * if some consent is missing from constants values
 * the modal will be shown
 * @param {consents} param0
 * @returns
 */
const checkIfModalConsentHasToShow = ({ consents = [] }) => {
  if (!consents || consents?.length === 0 || consents.error) {
    return false;
  }
  const consentsFromUser = consents.map((curr) => curr.consentId);
  const consentsNotValidated = CONSENTS_TO_VALIDATE.filter(
    (extEl) => !consentsFromUser.includes(extEl),
  );
  return !!consentsNotValidated.length;
};

export default checkIfModalConsentHasToShow;
